// src/components/OnionDisplay.tsx
import React from "react";
import LottieFromS3 from "./LottieFromS3";
import "../styles/OnionDisplay.css";

interface Props {
  score: number;
}

function getStage(progressInCycle: number): number {
  if (progressInCycle < 40) return 1;
  if (progressInCycle < 80) return 2;
  if (progressInCycle < 120) return 3;
  return 4;
}

/** ✅ AWS S3 Lottie URL */
const LOTTIE_MAP: Record<number, string> = {
  1: "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/lottie/onion1.json",
  2: "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/lottie/onion2.json",
  3: "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/lottie/onion3.json",
  4: "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/lottie/onion4_clean.json",
};

export default function OnionDisplay({ score }: Props) {
  const cycle = Math.floor(score / 120);
  const progressInCycle = score % 120;
  const stage = getStage(progressInCycle);

  return (
    <div className="onion-display">
      <div className="onion-lottie-box">
        <LottieFromS3 url={LOTTIE_MAP[stage]} />
      </div>
      <p>성장 단계 {stage}</p>
      <small>{cycle + 1}번째 양파</small>
    </div>
  );
}
